// 主页 登录 注册 密码修改
export default {
    "高指-智能工厂管理系统": "高指-智能工厂管理系统",
    "账户登录": "账户登录",
    "手机号": "手机号",
    "密码": "密码",
    "忘记密码": "忘记密码",
    "登 录": "登 录",
    "其他登录方式：": "其他登录方式：",
    "请用钉钉APP": "请用钉钉APP",
    "扫码二维码安全登录": "扫码二维码安全登录",
    "返回": "返回",
    "完善登录信息": "完善登录信息",
    "取 消": "取 消",
    "确 定": "确 定",
    "该项不能为空": "该项不能为空",
    "手机号输入格式有误": "手机号输入格式有误",
    "密码格式有误": "密码格式有误",
    "绑定成功！": "绑定成功！",
    "登录成功！": "登录成功！",
    "请输入手机号": "请输入手机号",
    "请输入验证码": "请输入验证码",
    "请设置新密码": "请设置新密码",
    "请确认新密码": "请确认新密码",
    "确 认": "确 认",
    "验证码格式有误": "验证码格式有误",
    "密码格式有误": "密码格式有误",
    "获取验证码": "获取验证码",
    "请输入正确的手机号！": "请输入正确的手机号！",
    "验证码已发送！": "验证码已发送！",
    "两次密码输入不一致！": "两次密码输入不一致！",
    "修改密码成功！": "修改密码成功！",
    "秒后重新获取": "秒后重新获取",
    "智能工厂": "智能工厂",
    "XOS管理": "XOS管理",
    "APS先进排程": "APS先进排程",
    "主页": "主页",
    "个人中心": "个人中心",
    "用户管理": "用户管理",
    "高指-智能工厂管理系统": "高指-智能工厂管理系统",
    "帮助文档": "帮助文档",
    "退出登录": "退出登录",
    "取消": "取消",
    'TaskMan 用户中心': 'TaskMan 用户中心',
    "用户管理编辑": "用户管理编辑"
}